import React from 'react';
import { Button } from 'react-bootstrap';
import './FloatingCheckoutButton.css';

const FloatingCheckoutButton = ({ onClick, disabled, itemCount }) => {
  return (
    <Button
      className="floating-checkout-btn d-md-none"
      onClick={onClick}
      disabled={disabled}
      variant="primary"
    >
      <i className="fas fa-shopping-cart me-2"></i>
      Checkout Now {itemCount > 0 && `(${itemCount})`}
    </Button>
  );
};

export default FloatingCheckoutButton;
